// extracted by mini-css-extract-plugin
export default {"pagingContainer":"HoaDonView_pagingContainer__Y3Cry"};